import { defineComponent } from 'vue';
import CategoryTwelveComponent from '@/components/CategoryTwelve/CategoryTwelveComponent.vue';
export default defineComponent({
    name: 'CategoryTwelve',
    components: { CategoryTwelveComponent },
    data() {
        return {};
    }
});
